<template>
  <div>
    <v-row class="mx-3">
      <v-col
        cols="6"
        class="pb-0"
      >
        <v-autocomplete
          v-model="company"
          v-validate="'required'"
          :loading="loading"
          :items="companies"
          :error-messages="errors.collect('company')"
          data-vv-name="company"  
          data-vv-as="company"  
          item-text="name"
          item-value="id"
          label="Company"
          outlined
        />
      </v-col>

      <v-col
        cols="6"
        class="pb-0"
      >
        <v-autocomplete
          v-model="payrollPeriod"
          v-validate="'required'"
          label="Payroll Period"
          :items="payrollPeriods"
          :item-text="item => $moment(item.payroll_date).format('MMM YYYY')"
          item-value="id"
          outlined
          :error-messages="errors.collect('payrollPeriod')"
          data-vv-name="payrollPeriod"  
          data-vv-as="payroll period"  
        />
      </v-col>

      <v-col
        cols="6"
        class="pb-0"
      >
        <v-text-field
          v-model="pcbReceiptNo"
          v-validate="'required'"
          label="PCB Receipt/Bank Slip/Transaction No"
          :error-messages="errors.collect('pcbReceiptNo')"
          outlined
          data-vv-name="pcbReceiptNo"  
          data-vv-as="PCB Receipt No"
        />
      </v-col>
      <v-col
        cols="6"
        class="pb-0"
      >
        <v-text-field
          v-model="cp38ReceiptNo"
          v-validate="'required'"
          label="CP38 Receipt/Bank Slip/Transaction No"
          :error-messages="errors.collect('cp38ReceiptNo')"
          outlined
          data-vv-name="cp38ReceiptNo"  
          data-vv-as="CP38 Receipt No"
        />
      </v-col>
      <v-col
        cols="6"
        class="pt-0"
      >
        <v-menu
          v-model="pcbTransactionDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
          max-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="pcbTransactionDate"
              v-validate="'required'"
              label="PCB transaction date"
              outlined
              readonly
              class="label-position"
              :error-messages="errors.collect('pcbTransactionDate')"
              data-vv-name="pcbTransactionDate"
              data-vv-as="PCB Transaction Date"  
              v-on="on"
            >
              <template v-slot:prepend-inner>
                <v-icon>
                  mdi-calendar
                </v-icon>
              </template>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="pcbTransactionDate"
            no-title
            @input="pcbTransactionDateMenu = false"
          /> 
        </v-menu>
      </v-col>
      <v-col
        cols="6"
        class="pt-0"
      >
        <v-menu
          v-model="cp38TransactionDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
          max-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="cp38TransactionDate"
              v-validate="'required'"
              label="CP38 transaction date"
              outlined
              readonly
              class="label-position"
              :error-messages="errors.collect('cp38TransactionDate')"
              data-vv-name="cp38TransactionDate"
              data-vv-as="CP38 Transaction Date"  
              v-on="on"
            >
              <template v-slot:prepend-inner>
                <v-icon>
                  mdi-calendar
                </v-icon>
              </template>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="cp38TransactionDate"
            no-title
            @input="cp38TransactionDateMenu = false"
          />
        </v-menu>
      </v-col>

      <v-col
        cols="12"
        class="text-right"
      >
        <v-btn
          color="hrissecondary"
          class="white--text"
          :loading="progressing"
          @click="submit"
        >
          Submit
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
    },
    data () {
      return {
        companies: [],
        company: null,
        payrollPeriods: [],
        payrollPeriod: null,
        loading: false,
        pcbReceiptNo: null,
        cp38ReceiptNo: null,
        pcbTransactionDateMenu: false,
        cp38TransactionDateMenu: false,
        pcbTransactionDate: null,
        cp38TransactionDate: null,
        progressing: false,
        arrearsCompany: null,
        arrearsPayrollPeriod: null,
        receiptNo: null,
        transactionDateMenu: false,
        transactionDate: null,
        appOrg: process.env.VUE_APP_ORG,
      }
    },
    created () {
      this.loading = true

      Promise.all([
        this.$api.payrollPeriods().list('?status=closed'),
        this.$api.hrisCompanies().list('?organization=' + this.appOrg),
      ])
        .then(([payrollPeriod, company]) => {
          this.payrollPeriods = payrollPeriod.data        
          this.companies = company.data

          this.loading = false
        })
    },
    methods: {
      submit () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.pcbStatements().create(this.prepareFormData())
              .then((res) => {
                this.$snack({ message: res.data.status })
              
                this.$validator.reset()
                this.company = null
                this.payrollPeriod = null
                this.pcbReceiptNo = null
                this.cp38ReceiptNo = null
                this.pcbTransactionDate = null
                this.cp38TransactionDate = null
              }).catch((e) => {
                this.$snack({ 
                  color: 'error',
                  message: e.response.data.message, 
                })
              }).then(() => {
                this.progressing = false
              })
          })
      },

      prepareFormData () {
        return {
          company: this.company,
          payroll_period: this.payrollPeriod,
          pcb_receipt_no: this.pcbReceiptNo,
          cp38_receipt_no: this.cp38ReceiptNo,
          pcb_transaction_date: this.pcbTransactionDate,
          cp38_transaction_date: this.cp38TransactionDate,
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
